import { useCallback, forwardRef, useContext } from 'react';
import { getDeliveryIdentifierType, getRecipientFieldName, getRecipientKey } from 'conversations-thread-data/channel-configuration/public/operators';
import { getAllRecipientsRemoved, getRecipientAdded, getRecipientRemoved
// TODO: move to composer-ui
} from '../../../usage-tracking/events/metadataEditorInteractions';
import RecipientField from './RecipientField';
import { useUpdateRecipients } from '../hooks/useUpdateRecipients';
import { EditorTrackerContext } from '../../../usage-tracking/context/EditorTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const logRecipientChange = (nextRecipients, prevRecipients, recipientType, trackEvent) => {
  recipientType = recipientType.toLowerCase();
  recipientType = recipientType === 'default' ? 'to' : recipientType;
  if (nextRecipients.size === 0) {
    const genericChannelId = prevRecipients.size ? prevRecipients.first().genericChannelId || undefined : undefined;
    trackEvent(getAllRecipientsRemoved({
      recipientType,
      genericChannelId
    }));
  } else {
    const genericChannelId = nextRecipients.first().genericChannelId || undefined;
    if (nextRecipients.size > prevRecipients.size) {
      trackEvent(getRecipientAdded({
        recipientType,
        genericChannelId
      }));
    } else if (nextRecipients.size < prevRecipients.size) {
      trackEvent(getRecipientRemoved({
        recipientType,
        genericChannelId
      }));
    }
  }
};
const _GenericRecipient = (props, ref) => {
  const {
    allRecipients,
    delayedExpanded,
    handleSetExpanded,
    index,
    isComposer,
    recipientField,
    recipientFieldsExpansionState,
    subfieldAutofocus,
    toLabel,
    onChange,
    reply,
    inboxId
  } = props;
  const fieldName = getRecipientFieldName(recipientField);
  const recipientKey = getRecipientKey(recipientField);
  const {
    updateRecipients
  } = useUpdateRecipients({
    onChange,
    reply,
    recipientField
  });
  const {
    trackEvent
  } = useContext(EditorTrackerContext);
  const valueChangeHandler = useCallback(nextRecipients => {
    updateRecipients(nextRecipients);
    if (recipientKey) {
      const recipientsForKey = allRecipients.get(recipientKey);
      logRecipientChange(nextRecipients, recipientsForKey, recipientKey, trackEvent);
    }
  }, [updateRecipients, allRecipients, recipientKey, trackEvent]);
  const deliveryIdentifier = getDeliveryIdentifierType(recipientField);
  return /*#__PURE__*/_jsx(RecipientField, {
    allRecipients: allRecipients,
    delayedExpanded: delayedExpanded,
    deliveryIdentifier: deliveryIdentifier,
    fieldName: fieldName,
    handleSetExpanded: handleSetExpanded,
    index: index,
    isComposer: isComposer,
    recipientFieldsExpansionState: recipientFieldsExpansionState,
    recipientKey: recipientKey,
    reply: reply,
    inboxId: inboxId,
    subfieldAutofocus: subfieldAutofocus,
    toLabel: toLabel,
    valueChangeHandler: valueChangeHandler,
    ref: ref,
    useWhatsAppCompose: true
  }, recipientKey);
};
_GenericRecipient.displayName = '_Recipient';
export const GenericRecipient = /*#__PURE__*/forwardRef(_GenericRecipient);